// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".export-title-header[data-v-70199075]{padding:20px 25px 0 25px;border-top:1px solid #d9dadb}.export-error[data-v-70199075],.export-success[data-v-70199075]{padding:15px}.export-error p[data-v-70199075],.export-success p[data-v-70199075]{font-weight:700;font-style:italic}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
